import { render, staticRenderFns } from "./subsidiaries.vue?vue&type=template&id=7d371f7e"
import script from "./subsidiaries.vue?vue&type=script&lang=js"
export * from "./subsidiaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports